import type { AnySectionItem } from '@wix/add-panel-common';
import { pipe } from 'ramda';
import { useProcessed } from '../../../../../utils/processPlaceholders';
import { useTextComponentsSkin } from '../useTextComponentsSkin';

export const useItemData = <Item extends AnySectionItem>(item: Item): Item =>
  pipe<Item, Item, Item>(useProcessed, useTextComponentsSkin)(item);
